import { EntityTag } from "#app/components/entity";
import { userRefToEntity } from "#app/lib/entity-visuals";
import type { OrgChartUser } from "./use-org-chart-data";
import type { OrgChartViewOptions } from "./org-chart-view-options";

/** Content inside an org-chart node card. The card shell (border, selection
 *  ring, press, collapse chip) is owned by the library's OrgChart — this only
 *  renders the person, through the mandatory entity chip system. The view
 *  options add the member's workspace role(s) as a KIND LABEL above the name
 *  (10px tracked caps, faint) and the job title as the muted line below it:
 *  a role is the kind of member they are, a title is what they wrote about
 *  themselves, and the two sit on opposite sides of the name so neither
 *  reads as a second copy of the other. Each line clamps alone and the
 *  clipped rest is one hover away (the chip is non-interactive, so no
 *  preview card competes with that tooltip). The card's box grows with the
 *  line count (orgChartNodeHeight); a member missing a line centers in it. */
export function OrgChartPersonContent({
  user,
  showTitle = true,
  showRole = false,
}: { user: OrgChartUser } & Partial<OrgChartViewOptions>) {
  const roles = user.roles.map((role) => role.roleName).join(", ");
  return (
    <EntityTag
      entity={userRefToEntity(user)}
      size="md"
      // 14px regular name over a 12px muted title — the ref's card type ramp.
      weight="regular"
      kindLabel={showRole && roles.length > 0 ? roles : undefined}
      description={showTitle && user.title ? user.title : undefined}
      interactive={false}
    />
  );
}
